<div class="grid-x grid-margin-x show-for-medium">
      <div class="cell small-6">
          <div class="grid-x grid-margin-x">
              <div class="cell small-5" *ngIf="flightDetails.highlightedFields">
                <span class="h4" [class.highlightFields]="flightDetails.highlightedFields.departTime">
                  {{departureTime}}
                </span>
              </div>
              <div class="cell small-1">
                <span aria-hidden="true" class="text-medium-gray icon-arrow-right flight-card-icon icon-medium"></span>
                <span class="show-for-sr" >{{'reaccom.to' | translate}}</span>
              </div>
              <div class="cell small-5" *ngIf="flightDetails.highlightedFields">
                <span class="h4" [class.highlightFields]="flightDetails.highlightedFields.arrivalTime">
                  {{arrivalTime}}
                </span>
              </div>
          </div>
      </div>
      <div class="cell small-3 flight-detail">
        <span class="h4">{{flightDetails.duration}}</span>
      </div>
      <div class="cell small-3 flight-detail xxtext-left" *ngIf="flightDetails.cabinClass">
        <span class="h4">{{flightDetails.cabinClass.name}}</span>
      </div>
</div>

<div class="hide-for-medium">
    <div class="grid-x grid-margin-x">
        <div class="cell small-3" *ngIf="flightDetails.highlightedFields">
          <span class="h3" [class.highlightFields]="flightDetails.highlightedFields.departTime">
            {{departureTime}}
          </span>
        </div>
        <div class="cell small-1">
          <span aria-hidden="true"
                class="text-medium-gray icon-arrow-right flight-card-icon icon-medium"></span>
          <span class="show-for-sr">to</span>
        </div>
        <div class="cell small-4" *ngIf="flightDetails.highlightedFields">
          <span class="h3" [class.highlightFields]="flightDetails.highlightedFields.arrivalTime">
            {{arrivalTime}}
          </span>
          <div class="flight-detail">
          <span>{{flightDetails.duration}}</span>
          </div>
        </div>
        <div class="cell small-3 flight-detail -mobile xxmargin-bottom -small">
          <span>{{flightDetails.cabinName}}</span>
        </div>
    </div>
</div>
